import React, { useEffect, useState } from 'react';
import { Search, SlidersHorizontal, Trophy } from 'lucide-react';
import { useContestantFilters } from '../../../stores/contestantFilters';
import { supabase } from '../../../lib/supabase';

interface Contest {
  id: string;
  name: string;
  status: string;
  end_date: string;
}

export const ContestantFilters = () => {
  const { search, contestId, sortBy, setSearch, setContestId, setSortBy } = useContestantFilters();
  const [contests, setContests] = useState<Contest[]>([]);

  useEffect(() => {
    const fetchContests = async () => {
      const { data } = await supabase
        .from('contests')
        .select('id, name, status, end_date')
        .order('name');
      const now = new Date();
      const filtered = (data || []).filter((contest: any) => {
        if (contest.status === 'completed') return false;
        if (contest.end_date && new Date(contest.end_date) < now) return false;
        return true;
      });
      setContests(filtered);
    };
    fetchContests();
  }, []);

  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Recherche */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="block w-full pl-10 pr-3 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent"
            placeholder="Rechercher un candidat..."
          />
        </div>

        {/* Filtre par concours */}
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Trophy className="h-5 w-5 text-gray-400" />
          </div>
          <select
            value={contestId}
            onChange={(e) => setContestId(e.target.value)}
            className="block w-full pl-10 pr-10 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent appearance-none"
          >
            <option value="" className="bg-gray-900">Tous les concours</option>
            {contests.map((contest) => (
              <option key={contest.id} value={contest.id} className="bg-gray-900">
                {contest.name}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <SlidersHorizontal className="h-5 w-5 text-gray-400" />
          </div>
        </div>

        {/* Tri */}
        <div className="relative">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="block w-full pl-3 pr-10 py-2.5 bg-white/5 border border-white/10 text-white rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500/50 focus:border-transparent appearance-none"
          >
            <option value="" className="bg-gray-900">Trier par</option>
            <option value="name" className="bg-gray-900">Nom</option>
            <option value="votes" className="bg-gray-900">Votes</option>
            <option value="created_at" className="bg-gray-900">Date d'ajout</option>
          </select>
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <SlidersHorizontal className="h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
};
